// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1OAuthIntrospectRequestSchema = z.object({
  token: z.coerce.string().min(1).describe("OAuth 2.0 access token to introspect"),
  token_type_hint: z.enum(["access_token", "refresh_token"]).describe("Hint about the type of token being introspected").nullish(),
});
